import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Education() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Human Practices
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Education
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Education
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Education-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Overview
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Education-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Learning about Synthetic Biology Through a Board Game
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Education-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    iGEM Stockholm Celebration Game
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Education-4")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    St. Martins Gymnasium Workshop
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Education-5")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Career Fairs and Welcome Events for New University Students
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Education-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Overview
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                One of the key stages in the iGEM engineering process is the learning phase, which
                                provides the foundation for subsequent activities. The Stockholm team is committed to
                                raising awareness about the potential of synthetic biology within society. To this
                                end, special educational discussions were held to provide information about the
                                potential of synthetic biology to address societal issues and to gain insight into
                                how our project can contribute to addressing those problems. Furthermore, to reach a
                                wider audience through interactive learning, two educational games about synthetic
                                biology were created: a board game and a digital game.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Education-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Learning about Synthetic Biology Through a Board Game
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                This year, the iGEM Stockholm team has joined forces with four other Swedish iGEM
                                teams (Lund, Linköping, Gothenburg and Uppsala) to create an educational game that
                                will help people understand the basic principles behind synthetic biology research.
                                By showcasing the potential of synthetic biology and explaining how it works in a
                                simple interactive way, we hope to raise awareness of the production of GMO and their
                                derivatives. Furthermore, this five iGEM teams collaboration demonstrates the
                                effectiveness of group work when there is a common goal.
                            </div>
                            <div className="mt-5 font-bold">
                                About the game
                            </div>
                            <div className="mt-5">
                                This game, developed in collaboration with the other Swedish iGEM teams, serves as
                                an engaging and practical tool for teaching the core principles of synthetic biology.
                                By guiding players through the process of
                                assembling genetic parts, incubating plasmids, transforming bacteria, and
                                expressing proteins, the game mirrors real-world lab techniques in a simplified,
                                interactive format. Players not only learn the scientific process of genetic
                                engineering but also see how these concepts can be applied to solve real-world
                                problems, as many of the projects are based on actual iGEM team ideas. The game
                                can be used in classrooms or outreach programs to introduce students and the
                                general public to synthetic biology in a fun and approachable way. By offering
                                hands-on experience with key concepts, it helps clarify complex processes and
                                fosters a deeper understanding of the field’s potential applications in
                                biotechnology, medicine, environmental science and elsewhere.
                            </div>
                            <div className="w-full h-screen mt-5">
                                <object
                                    type="application/pdf"
                                    width="100%"
                                    height="100%"
                                    data="https://static.igem.wiki/teams/5176/boardgame/plasmid-assembler-cards-final.pdf"
                                >
                                    <p>Your web browser doesn't have a PDF plugin.</p>
                                </object>
                            </div>
                            <div className="w-full h-screen mt-5">
                                <object
                                    type="application/pdf"
                                    width="100%"
                                    height="100%"
                                    data="https://static.igem.wiki/teams/5176/boardgame/plasmid-assembler-rules.pdf"
                                >
                                    <p>Your web browser doesn't have a PDF plugin.</p>
                                </object>
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/education/education-1.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <img
                                src="https://static.igem.wiki/teams/5122/education/education-2.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                        </div>
                    </div>
                    <div>
                        <div id="Education-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            iGEM Stockholm Celebration Game
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div className="font-bold">
                                Motivation
                            </div>
                            <div className="mt-5">
                                In order to celebrate the 10th participation of the Stockholm team into the iGEM
                                competition, an educational digital game encompassing all the 10 projects so far
                                has been created. The game was developed in response to the need to increase
                                societal knowledge about synthetic biology by demonstrating how the 10 iGEM
                                Stockholm teams have applied it to address societal needs in a digital format. We
                                invite you to engage with us on this journey from a research idea brainstorming to the iGEM Gran
                                Jamboree by clicking
                                <a
                                    href="https://gx.games/games/bdfkhc/igem2024-stockholm/tracks/996855ef-7b90-485d-958a-72e4facd1998/"
                                    target="_blank"
                                    className="underline text-blue-500 ml-2"
                                    rel="noopener noreferrer"
                                >here</a>.
                            </div>
                            {/*<img*/}
                            {/*    src="https://static.igem.wiki/teams/5122/education/education-3.png"*/}
                            {/*    className="w-full mt-5 rounded-2xl"*/}
                            {/*    alt=""*/}
                            {/*/>*/}
                            <img
                                src="https://static.igem.wiki/teams/5122/add/add-4.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <div className="font-bold mt-5">
                                Working environment and tools
                            </div>
                            <div className="mt-5">
                                GameMaker Studio 2 is the game development tool used for the creation of our
                                educational video game. Our decision was based on the software's open-source nature,
                                accessibility, and user-friendly interface, which facilitate collaboration between
                                team members. Furthermore, the cross-platform capabilities of GameMaker Studio 2
                                enable us to potentially reach a broader audience, extending the reach of our
                                educational initiative through a simple link:
                            </div>
                            <div className="mt-5">
                                https://gx.games/games/bdfkhc/igem2024-stockholm/tracks/996855ef-7b90-485d-958a-72e4facd1998/
                            </div>
                            <div className="mt-5">
                                The flexible game engine has enabled us to create an engaging and educational
                                gaming experience that clearly  shows how bioengineering projects are developed.
                                It will be accessible to a wide audience, including interested students and the
                                general public of all ages.
                            </div>
                            <div className="mt-5">
                                The sprites in the computer game were designed using Canva.
                            </div>
                            <div className="mt-5">
                                Games, Y., 2014. GameMaker: Studio, Available at:
                            </div>
                            <div className="mt-5">
                                https://www.yoyogames.com/gamemaker
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/add/add-6.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <div className="mt-5 font-bold">
                                About the game
                            </div>
                            <div className="mt-5">
                                The iGEM Stockholm digital game is in the style of a board game.
                            </div>
                            <div className="mt-5">
                                The goal of the game is to move through all the paths to reach the final Grand
                                Jamboree. In particular, this would be a journey through the development of a
                                synthetic biology research idea. Therefore, each step corresponds to a specific
                                phase of research development: brainstorming phase, grant application, dry lab
                                simulations, wet lab experiments, human practice activities (participation in
                                conferences and research discussions), media communication and finally the iGEM
                                Grand Jamboree to present the project and network with other researchers!
                            </div>
                            <div className="mt-5">
                                It is possible to play alone or in a group by choosing one of the two pieces (each
                                piece is associated with a die). By rolling the dice, you can start your journey
                                towards completing one of the 10 iGEM Stockholm synthetic biology research projects.
                            </div>
                            <div className="mt-5">
                                Be aware that research can be tricky, so you might hit some bumps (red positions)
                                along the way... But do not worry, sometimes surprising results (green positions)
                                will allow you to move faster.
                            </div>
                            <div className="mt-5">
                                Will you be able to reach the iGEM Grand Jamboree first?
                            </div>
                            <div className="mt-5">
                                If you are ready to discover which synthetic biology projects have been carried out
                                by the iGEM Stockholm teams over the past decade, START playing our fun game:
                            </div>
                            <div className="mt-5">
                                https://gx.games/games/bdfkhc/igem2024-stockholm/tracks/996855ef-7b90-485d-958a-72e4facd1998/
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/add/add-3.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <img
                                src="https://static.igem.wiki/teams/5122/add/add-7.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <div className="mt-5 font-bold">
                                Pseudocode
                            </div>
                            <div className="mt-5">
                                Start button leads from the main room to the game room:
                            </div>
                            <div className="mt-5">
                                By clicking two times on one die:
                            </div>
                            <div className="mt-5 ml-8">
                                One random number between 1 and 6 is showing
                            </div>
                            <div className="mt-5 ml-8">
                                The related piece moves of as many position as the number on the die
                            </div>
                            <div className="mt-5 ml-8">
                                A pop us shows some information about that position
                            </div>
                            <div className="mt-5 ml-8">
                                If click on OK
                            </div>
                            <div className="mt-5 ml-8">
                                Pop up closes
                            </div>
                            <div className="mt-5 ml-8">
                                Next turn starts
                            </div>
                            <div className="mt-5">
                                By clicking two times on the die (same die or the other die for 2 players experience)
                            </div>
                            <div className="mt-5 ml-8">
                                One random number between 1 and 6 is showing
                            </div>
                            <div className="mt-5 ml-8">
                                The related piece moves of as many position as the number on the die
                            </div>
                            <div className="mt-5 ml-8">
                                A pop us shows some information about that position
                            </div>
                            <div className="mt-5 ml-8">
                                If click on OK
                            </div>
                            <div className="mt-5 ml-8">
                                Pop up closes
                            </div>
                            <div className="mt-5 ml-8">
                                Next turn starts
                            </div>
                            <div className="mt-5">
                                If piece is on red spot:
                            </div>
                            <div className="mt-5 ml-8">
                                Go back to x
                            </div>
                            <div className="mt-5">
                                If piece is on red spot:
                            </div>
                            <div className="mt-5 ml-8">
                                Move to x
                            </div>
                            <div className="mt-5">
                                Position 73 means winning:
                            </div>
                            <div className="mt-5 ml-8">
                                Go to winning room
                            </div>
                            <div className="mt-5">
                                The full code for the game has been uploaded on github and can be made available
                                upon reasonable request at: https://github.com/DiandraDaum/
                            </div>

                        </div>
                    </div>
                    <div>
                        <div id="Education-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            St. Martins Gymnasium Workshop
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                In light of the crucial role of incorporating user feedback into the development
                                of our final product, we were delighted to engage in a discussion about the ethical
                                and sustainable aspects of cosmetic ingredients with the students and faculty at St.
                                Martins Gymnasium, who specialise in makeup styling. Gaining insight into how to
                                meet the needs of clients attending make-up sessions is a key responsibility for
                                a make-up stylist. The discussion about alternatives to non-vegan and unethical
                                products available nowadays has proved both enlightening for the students and an
                                excellent opportunity for us to promote our product and receive feedback on how it
                                would be received in the cosmetics industry.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/education/education-4.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <img
                                src="https://static.igem.wiki/teams/5122/education/education-5.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                        </div>
                    </div>
                    <div>
                        <div id="Education-5" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Career Fairs and Welcome Events for New University Students
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                It is vital to introduce more people to the field of synthetic biology in order to
                                raise awareness of its potential impact on society and to highlight how it can be
                                used to address a number of current issues. By doing so, we were able to gain inputs
                                back from a variety of backgrounds, which enabled us to complete the educational
                                phase of the engineering loop that we have been following throughout the development
                                of our project. Our educational effort included participation in:
                            </div>
                            <div className="mt-5">
                                1. Organlunchen: presentation of the iGEM competition and our current project to
                                new students of the Chemistry chapter at KTH. Nice presentation of the potential
                                of synthetic biology to new minds that may consider focusing in this exciting field.
                            </div>
                            <div className="mt-5">
                                2. Infopub: the relaxed atmosphere of the university infopub provided an ideal
                                setting for introducing students to the potential implications of synthetic biology
                                applications, while also offering valuable insights into the effectiveness of our
                                project.
                            </div>
                            <div className="mt-5">
                                3. Kick-off of university programs at Karolinska Institutet, KTH and Stockholm
                                university: given that the iGEM Stockholm team is open to students from a range
                                of academic backgrounds, we believe it is crucial to raise awareness among the
                                wider student community in Stockholm about the potential of synthetic biology to
                                address societal needs and the opportunity to join the iGEM Stockholm team in the
                                coming years. It is worth noting that a significant portion of the knowledge gained
                                during university may originate from activities in which students choose to
                                participate. iGEM presents an invaluable opportunity for involvement in a research
                                project from a multitude of perspectives, including wet lab, dry lab, media, human
                                practices, and finance. We trust that by sponsoring the iGEM competition more people
                                have become aware of synthetic biology impact and may consider joining the upcoming
                                years iGEM teams in order to provide new applications of it.
                            </div>
                            <div className="mt-5">
                                4. ForskarFredag: considering that the Researchers’ Fair ForskarFredag (Researcher
                                -Friday) is organised to allow researchers to showcase their research in an
                                interactive way, iGEM Stockholm could not miss it! By providing an opportunity to
                                discuss synthetic biology and our project, as well as to introduce students to
                                fundamental and secure laboratory techniques (all potential risks were considered),
                                we believe we have achieved our objective of introducing as many students as
                                possible to the potential impact of research, particularly in the context of
                                synthetic biology.
                            </div>
                        </div>
                        <img
                            src="https://static.igem.wiki/teams/5122/add/add-5.png"
                            className="w-full mt-5 rounded-2xl"
                            alt=""
                        />
                    </div>


                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}